import type { SVGProps } from 'react'

/**
 * One drawn icon set for the token pages: 24px grid, 1.75 stroke, round caps and joins, currentColor. No emoji, no glyph fonts.
 * Brand marks (X, Telegram, Discord) are simplified outlines, not the companies' logos.
 */
const P: Record<string, string> = {
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM16.2 16.2 21 21',
  copy: 'M9 9h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1zM5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1',
  check: 'm5 12.5 4.5 4.5L19 7.5',
  external: 'M7 17 17 7M8.5 7H17v8.5',
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c2.4 2.5 3.6 5.5 3.6 9S14.4 18.5 12 21c-2.4-2.5-3.6-5.5-3.6-9S9.6 5.5 12 3z',
  x: 'M5 4.5 19 19.5M19 4.5 5 19.5',
  telegram: 'M20.5 4 3.5 10.8l5.3 2 1.7 5.4 2.9-3.3 4.7 3.5L20.5 4zM8.8 12.8 20.5 4',
  discord: 'M8 7.5c1.3-.6 2.6-.9 4-.9s2.7.3 4 .9c1.8 2.2 2.8 4.8 3.2 7.9-1.2.9-2.5 1.5-3.9 1.9l-.9-1.6c.5-.2.9-.4 1.3-.7-2.2.9-4.6.9-6.8 0 .4.3.8.5 1.3.7l-.9 1.6c-1.4-.4-2.7-1-3.9-1.9C5.2 12.3 6.2 9.7 8 7.5zM9.8 12.4h.01M14.2 12.4h.01',
  cmc: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM7.5 15.5v-6l3.2 4.4 2.6-5 2.4 4 1.8-1.4',
  shield: 'M12 3 19 6v5.5c0 4.4-2.9 7.8-7 9.5-4.1-1.7-7-5.1-7-9.5V6l7-3z',
  shieldCheck: 'M12 3 19 6v5.5c0 4.4-2.9 7.8-7 9.5-4.1-1.7-7-5.1-7-9.5V6l7-3zM8.6 12.2l2.4 2.4 4.4-4.6',
  trophy: 'M8 4h8v5a4 4 0 0 1-8 0V4zM8 6H5v1.5A3 3 0 0 0 8 10.5M16 6h3v1.5a3 3 0 0 1-3 3M12 13v4M8.5 20h7M10 17h4',
  wallet: 'M4 7.5A2.5 2.5 0 0 1 6.5 5H18v3M4 7.5V17a2 2 0 0 0 2 2h13a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H6.5A2.5 2.5 0 0 1 4 7.5zM16 13.5h.01',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7.5V12l3 2',
  info: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 11v5M12 8h.01',
  upload: 'M12 16V5M8 9l4-4 4 4M5 19h14',
  plus: 'M12 5v14M5 12h14',
  close: 'M6 6l12 12M18 6 6 18',
  chevronRight: 'm9 5 7 7-7 7',
  chevronLeft: 'm15 5-7 7 7 7',
  chevronDown: 'm5 9 7 7 7-7',
  arrowLeft: 'M19 12H5M11 6l-6 6 6 6',
  trend: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  spark: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3zM19 16l.7 1.8L21.5 18.5l-1.8.7L19 21l-.7-1.8-1.8-.7 1.8-.7L19 16z',
  bars: 'M5 20V11M12 20V4M19 20v-6',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20a7.5 7.5 0 0 1 15 0',
  users: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 19.5a6.5 6.5 0 0 1 13 0M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14a6 6 0 0 1 3.5 5.5',
  arrowUp: 'M12 19V5M6 11l6-6 6 6',
  arrowDown: 'M12 5v14M6 13l6 6 6-6',
  layers: 'm12 3 9 5-9 5-9-5 9-5zM3 13l9 5 9-5',
  lock: 'M6 11h12a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1zM8 11V8a4 4 0 0 1 8 0v3',
  warning: 'M12 4 2.5 20h19L12 4zM12 10v4.5M12 17.5h.01',
  refresh: 'M20 12a8 8 0 1 1-2.4-5.7M20 4v4.5h-4.5',
}
export type IconName = keyof typeof P

export function Icon({ name, size = 20, ...rest }: { name: IconName; size?: number } & Omit<SVGProps<SVGSVGElement>, 'name'>) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" style={{ flex: 'none' }} {...rest}>
      <path d={P[name]} />
    </svg>
  )
}
